import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BroadcastService',
    controller: 'Playlist'
};
const methods = [
    'AddPlaylist',
    'DeletePlaylist',
    'UpdatePlaylist',
    'FindPlaylist',
    'AddPlaylistItem',
    'DeletePlaylistItem',
    'DeletePlaylistItemByPlaylistId',
    'UpdatePlaylistItem',
    'FindPlaylistItem',
    'GetPlaylistItem'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const PlayList = ZJApi.defineNewApi('PlayList', factory);

export default PlayList;